module.exports = __webpack_public_path__ + "static/img/Y-merkki_logo_vaaka_suomi_white.5afe3ec.png";